var _Rect, _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Rect, Path } from "react-native-svg";
function SvgEmail(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Rect || (_Rect = /*#__PURE__*/React.createElement(Rect, {
    x: 1.75,
    y: 2.917,
    width: 10.5,
    height: 8.167,
    rx: 2,
    stroke: "#B4B7BD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M1.75 4.083L7 7.583l5.25-3.5",
    stroke: "#B4B7BD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgEmail;